import { Card, CardContent } from "@/components/ui/card"
import { Users, PieChart as PieChartIcon, UserMinus } from "lucide-react"
import { COLORS } from "./constants"
import type { RaceCount } from "./types"

interface DistributionSummaryCardsProps {
  totalPlayers: number
  playersWithRaces: number
  playersWithoutRaces: number
  raceStats: RaceCount[]
}

export const DistributionSummaryCards = ({
  totalPlayers,
  playersWithRaces,
  playersWithoutRaces,
  raceStats,
}: DistributionSummaryCardsProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <Card className="dark:bg-gray-800">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-300 truncate">
              Total Jugadores
            </p>
            <p className="text-xl sm:text-2xl font-bold dark:text-gray-100">{totalPlayers}</p>
          </div>
          <Users className="h-6 w-6 sm:h-8 sm:w-8 text-muted-foreground dark:text-gray-300 flex-shrink-0" />
        </div>
      </CardContent>
    </Card>

    <Card className="dark:bg-gray-800">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-300 truncate">
              Con Raza Asignada
            </p>
            <p className="text-xl sm:text-2xl font-bold dark:text-gray-100">{playersWithRaces}</p>
          </div>
          <PieChartIcon className="h-6 w-6 sm:h-8 sm:w-8 text-muted-foreground dark:text-gray-300 flex-shrink-0" />
        </div>
      </CardContent>
    </Card>

    <Card className="dark:bg-gray-800">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-300 truncate">
              Sin Raza Asignada
            </p>
            <p className="text-xl sm:text-2xl font-bold dark:text-gray-100">
              {playersWithoutRaces}
            </p>
          </div>
          <UserMinus className="h-6 w-6 sm:h-8 sm:w-8 text-muted-foreground dark:text-gray-300 flex-shrink-0" />
        </div>
      </CardContent>
    </Card>

    <Card className="sm:col-span-2 lg:col-span-1 dark:bg-gray-800">
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-300 truncate">
              Razas Diferentes
            </p>
            <p className="text-xl sm:text-2xl font-bold dark:text-gray-100">
              {raceStats.filter((x) => x.name !== "Sin raza").length}
            </p>
          </div>
          <div className="flex space-x-1 flex-shrink-0">
            {raceStats.slice(0, 3).map((_, index) => (
              <div
                key={index}
                className="w-2 h-6 sm:h-8 rounded"
                style={{ backgroundColor: COLORS[index] }}
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
)
